import { businessKey } from 'queryKeys';

const LOOKALIKE_AUDIENCES = 'lookalikeAudiences';
const lookalikeAudiencesQuery = businessKey.query(LOOKALIKE_AUDIENCES);

export const grid = lookalikeAudiencesQuery.grid();
export const mutations = lookalikeAudiencesQuery.mutations();
export const details = lookalikeAudiencesQuery.details();
export const model = lookalikeAudiencesQuery.exact();
export const sharedAccounts = lookalikeAudiencesQuery.next('sharedAccounts');

export const create = mutations.create();
export const remove = mutations.delete();
export const removeSharedAccount = mutations.mutate('removeSharedAccount');
export const share = mutations.mutate('share');
export const update = mutations.update();
